import "./PopupStyle.css"
interface Props{
  title: string;
  message: string;
  descriptions: string,
  acceptText: string;
  cancelText: string;
  isBackIterated: boolean,
  onAccept: () => void;
  onCancel: () => void;
  onCrossClick: () => void;
}

const ConfirmationPopup = (prop:Props) => {
  return (
    <div className='ConfirmationPopup'>
      <div className="popupWrap">
        <button className='closeBtn btnNoStyle' onClick={prop.onCrossClick}>
          <img src={prop.isBackIterated ? "./assets/images/cross-s.png" : "./../assets/images/cross-s.png"} alt="" />
        </button>
        <div className="titleBlock">
          <h2>{prop.title} </h2>
          {prop.descriptions.trim() && <p>{prop.descriptions}</p>}
          {prop.message.trim() && <p>{prop.message}</p>}
        </div>
        <div className='bottomBlock d-flex justify-content-center'>
        {prop.acceptText.trim() &&  <button className='lightBlueBtn' type="submit" onClick={prop.onAccept} >{prop.acceptText}</button>}
        {prop.cancelText &&  <button className='blueBorderBtn' type="submit" onClick={prop.onCancel}>{prop.cancelText}</button>}
        </div>
      </div>
    </div>
  )
}

export default ConfirmationPopup;